var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0581 5.11438H8.88652H6.0581ZM8.88652 5.11438V7.94281V5.11438ZM8.88652 5.11438L5.11529 8.88562L8.88652 5.11438ZM11.2435 2.75736C11.8007 3.31451 12.2427 3.97595 12.5442 4.7039C12.8457 5.43185 13.0009 6.21207 13.0009 7C13.0009 7.78793 12.8457 8.56815 12.5442 9.2961C12.2427 10.0241 11.8007 10.6855 11.2435 11.2426C10.6864 11.7998 10.025 12.2417 9.29701 12.5433C8.56905 12.8448 7.78884 13 7.00091 13C6.21297 13 5.43276 12.8448 4.70481 12.5433C3.97685 12.2417 3.31542 11.7998 2.75827 11.2426C1.63305 10.1174 1.00091 8.5913 1.00091 7C1.00091 5.4087 1.63305 3.88258 2.75827 2.75736C3.88348 1.63214 5.40961 1 7.00091 1C8.59221 1 10.1183 1.63214 11.2435 2.75736Z",
    stroke: "#E76F51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReport);
export default __webpack_public_path__ + "static/media/view-report.68152d9e9d0e46f1a10392774e3aa265.svg";
export { ForwardRef as ReactComponent };